/**
 * Sidebar active-path helpers.
 * Prefer the longest matching menu path so nested routes (e.g. /crm/trustvid)
 * do not also highlight a parent item (/crm).
 */

export function pathMatchesSidebarItem(pathname, itemPath) {
  if (!pathname || !itemPath) return false;
  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
}

export function isSidebarItemActive({ pathname, itemPath, siblingPaths = [] } = {}) {
  if (!pathMatchesSidebarItem(pathname, itemPath)) {
    return false;
  }
  return !siblingPaths.some(
    (otherPath) =>
      Boolean(otherPath) &&
      otherPath.length > itemPath.length &&
      pathMatchesSidebarItem(pathname, otherPath)
  );
}
